import Image from 'app/Components/Shared/Image/image';
import React from 'react';

const IconTextPair = ({icon, textTitle,text, isTopIcon}) => {
  return (
    <div className={`icon-text-pair ${isTopIcon ? 'topIcon' : ''}`}>
      {icon && <Image className='icon' src={icon} />}
      <div className='text-container'>
        {textTitle && <div className='text-title'>{textTitle}</div>}
        {text && <div className='text'>{text}</div>}
      </div>
    </div>
  );
}

export default IconTextPair;
